module.exports = __webpack_public_path__ + "static/media/blog-39-1.492eb832.webp";